import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const ADMIN_TOKEN_KEY = "happytails_admin_token";

export const adminApi = () => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY) || "";
  return axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Password": token },
  });
};

export const MEET_GREET_SLOTS = [
  "9:00 AM",
  "10:00 AM",
  "11:00 AM",
  "1:00 PM",
  "2:00 PM",
  "3:00 PM",
  "4:00 PM",
  "5:00 PM",
];

export const SERVICES = [
  { id: "potty-15", label: "15-min Potty Break", price: 12, category: "Dog Walking" },
  { id: "walk-30", label: "30-min Walk", price: 20, category: "Dog Walking" },
  { id: "walk-60", label: "60-min Adventure Walk", price: 35, category: "Dog Walking" },
  { id: "drop-in", label: "Drop-in Visit (per time, per day)", price: 15, category: "Pet Sitting" },
  { id: "overnight", label: "Overnight Stay", price: 75, category: "Pet Sitting" },
  { id: "vacation", label: "Vacation Care Package (per day)", price: 50, category: "Pet Sitting" },
];

export const ADDONS = [
  { id: "additional-pet", label: "Additional Pet", price: 5, kind: "flat" },
  { id: "medication", label: "Medication Administration", price: 5, kind: "flat" },
  { id: "holiday", label: "Holiday Visit", price: 0.2, kind: "percent" },
];

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_happy-tails-aurora/artifacts/2mosnl1y_ChatGPT%20Image%20Jun%204%2C%202026%2C%2003_43_58%20PM.png";

export const SOCIAL = {
  phone: "(931) 787-0018",
  phoneRaw: "9317870018",
  email: "happytailsbyaurora@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61590426819205",
  instagram: "https://instagram.com/happytailsbyaurora",
  instagramHandle: "@happytailsbyaurora",
  area: "Byron-Bergen area",
};
